import { StatusBadge, type StatusTone } from "@/design-system/components/ui";
import { useDateFormatter } from "@/utils/datetime";
import { introCardCopy } from "./introCardCopy";
import type { IntroCardStatus } from "./introCardStatus";

/** The pill's words for a status (D3, J3). `logged` picks "Copied — not logged"
 *  over "Copied — not recorded" for the cards whose record button is LOG. */
export function introCardPillLabel(
  status: IntroCardStatus,
  formatDate: (iso: string) => string,
  opts: { logged?: boolean } = {},
): string {
  switch (status.state) {
    case "notDrafted":
      return introCardCopy.notDrafted;
    case "draftSaved":
      return introCardCopy.draftSaved;
    case "copied":
      return opts.logged ? introCardCopy.copiedNotLogged : introCardCopy.copiedNotRecorded;
    case "sent":
      return introCardCopy.sent(formatDate(status.date), status.how);
    case "logged":
      return introCardCopy.logged(formatDate(status.date));
  }
}

const TONE: Record<IntroCardStatus["state"], StatusTone> = {
  notDrafted: "neutral",
  draftSaved: "info",
  copied: "warn",
  sent: "ok",
  logged: "ok",
};

/** Exactly one pill per card (D3), in the existing badge palette. */
export function IntroCardPill({ status, logged }: { status: IntroCardStatus; logged?: boolean }) {
  const { date } = useDateFormatter();
  return (
    <StatusBadge tone={TONE[status.state]} data-state={status.state}>
      {introCardPillLabel(status, (iso) => date(iso), { logged })}
    </StatusBadge>
  );
}
